<template>
  <section>
    <div class="container">
      <div class="apexcharts"  @mouseleave="mouseleftchart">
        <apexchart
          height="250"
          :options="headPoseChartOptions"
          :series="headPostSeries"
        />
        <div v-if="currentHeadPoseImage" class="">
          <img :src="currentHeadPoseImage" class="head-pose-image" alt="image"/>`
        </div>
      </div>
      <div class="apexcharts" @mouseleave="mouseleftchart">
        <apexchart
          height="250"
          :options="ambulatorySpeedChartOptions"
          :series="ambulatorySpeedSeries"
        />
        <div v-if="asCurrentDataPointIndex" class="">
          <font-awesome-icon icon="shoe-prints">
          </font-awesome-icon>&nbsp;
          <a :href="ambulatorySpeedData[asCurrentDataPointIndex].source_url" target="popup">Start</a>
          ({{ambulatorySpeedData[asCurrentDataPointIndex].source_description}}) to
          <a :href="ambulatorySpeedData[asCurrentDataPointIndex].destination_url" target="_blank">end</a>
          ({{ambulatorySpeedData[asCurrentDataPointIndex].destination_description}})
          :
          {{ambulatorySpeedData[asCurrentDataPointIndex].duration.toFixed(0)}} seconds
        </div>
      </div>
    </div>
    <div class="container">
      <div class="apexcharts">
      </div>
    </div>
  </section>
</template>

<script>
import { loadHeadPoseDataByFaceUUID, loadAmbulatorySpeedByFaceUUID } from '@/libraries/api/faces'
import { mapGetters } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'FaceStats.vue',
  props: ['faceUUID'],
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      headPoseData: [],
      hpCurrentDataPointIndex: null,
      asCurrentDataPointIndex: null,
      ambulatorySpeedData: [],
      useHeadPoseReferenceData: true,
      securityCameraIcon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 128 128"><g><path d="M127.125,55.9l-78-45.031A9.762,9.762,0,0,0,35.81,14.436L26.83,29.989,20.852,40.342a9.763,9.763,0,0,0,3.57,13.319L51.165,69.1l-4.159,7.092a6.275,6.275,0,0,1-5.392,3.089H26v-11.9a1.75,1.75,0,0,0-1.75-1.75h-9.5V63.373A7.759,7.759,0,0,0,7,55.623H1.75A1.749,1.749,0,0,0,0,57.373V116.69a1.749,1.749,0,0,0,1.75,1.75H7a7.759,7.759,0,0,0,7.75-7.75v-5.559h9.5a1.75,1.75,0,0,0,1.75-1.75v-8.6H41.614A21.834,21.834,0,0,0,60.376,84.036l4.213-7.184,14.659,8.463a9.7,9.7,0,0,0,4.858,1.31,9.8,9.8,0,0,0,2.54-.336A9.689,9.689,0,0,0,90.881,83.9,14.579,14.579,0,0,0,97,85.254a14.813,14.813,0,0,0,3.836-.508,14.614,14.614,0,0,0,7.971-5.4l3.584,2.069a1.749,1.749,0,0,0,2.391-.641l12.98-22.481A1.751,1.751,0,0,0,127.125,55.9ZM11.25,110.69A4.254,4.254,0,0,1,7,114.94H3.5V59.123H7a4.254,4.254,0,0,1,4.25,4.25V110.69Zm11.25-9.059H14.75v-32.5H22.5v32.5ZM57.356,82.265a18.318,18.318,0,0,1-15.742,9.017H26v-8.5H41.614a9.788,9.788,0,0,0,8.411-4.818L54.2,70.852l7.362,4.25ZM81,82.284,26.172,50.63a6.257,6.257,0,0,1-2.288-8.538l5.1-8.837,50.247,29.01,15.405,8.894L89.535,80l-.007.011a6.176,6.176,0,0,1-.441.65l0,.007A6.256,6.256,0,0,1,81,82.284Zm18.937-.919A11.155,11.155,0,0,1,93,81l4.673-8.093,8.093,4.672A11.155,11.155,0,0,1,99.935,81.365Zm12.695-3.86-11.317-6.534L97.9,69,59.263,46.694,30.736,30.224l8.105-14.038A6.257,6.257,0,0,1,47.379,13.9l76.48,44.157Z"/><path d="M105.154,67.993a6.689,6.689,0,0,0,3.355.905,6.775,6.775,0,0,0,1.752-.232,6.73,6.73,0,1,0-5.107-.673Zm.569-7.443a3.211,3.211,0,0,1,1.961-1.5,3.264,3.264,0,0,1,.84-.111,3.233,3.233,0,1,1-2.8,1.616Z"/><path d="M45.5,50.27,31.16,41.989a1.75,1.75,0,1,0-1.75,3.031L43.754,53.3A1.75,1.75,0,0,0,45.5,50.27Z"/></g></svg>',
      headPoseDataStatus: 'Loading data',
    }
  },
  watch: {
    async useHeadPoseReferenceData (newVal) {
      const { data } = await loadHeadPoseDataByFaceUUID(this.currentDomainUUID, this.faceUUID, !newVal)
      this.headPoseData = data.data
    },
  },
  async mounted() {
    console.log('mounted')
    this.headPoseDataStatus = 'Loading data'
    const [{ data: hpData }, { data: asData }] = await Promise.all([
      await loadHeadPoseDataByFaceUUID(this.currentDomainUUID, this.faceUUID),
      await loadAmbulatorySpeedByFaceUUID(this.currentDomainUUID, this.faceUUID),
    ])
    this.headPoseData = hpData.data
    this.headPoseDataStatus = 'No data available'
    this.ambulatorySpeedData = asData.data
    console.log('fetched everything')
    if (this.headPoseData.length === 0) {
      // if there are no reference data, try global data
      console.log('getting global data')
      const globalHpData = await loadHeadPoseDataByFaceUUID(this.currentDomainUUID, this.faceUUID, false)
      this.headPoseData = globalHpData.data
    }
  },
  methods: {
    formatHour(date) {
      return date.toLocaleTimeString('en-US', { month: 'short', day: 'numeric', hour: 'numeric' })
    },
    mouseleftchart() {
      this.hpCurrentDataPointIndex = null
      this.asCurrentDataPointIndex = null
    },
  },
  computed: {
    ...mapGetters({
      currentDomainUUID: 'currentDomainUUID',
    }),
    ambulatorySpeedSeries () {
      const speed = this.ambulatorySpeedData.map(s => s.duration)
      return [
        { name: 'speed', type: 'line', data: speed },
      ]
    },
    headPostSeries () {
      const angle = this.headPoseData.map(s => s.angle)
      return [
        { name: 'angle', type: 'line', data: angle },
      ]
    },
    currentHeadPoseImage () {
      return this.hpCurrentDataPointIndex ? this.headPoseData[this.hpCurrentDataPointIndex].image : null
    },
    headPoseChartOptions () {
      return {
        chart: {
          type: 'line',
          id: 'vuechart-hp',
          toolbar: {
            tools: {
              customIcons: [{
                icon: this.securityCameraIcon,
                index: 4,
                title: 'toggle reference camera',
                class: 'custom-icon__headpose_chart',
                click: (chart, options, e) => {
                  this.useHeadPoseReferenceData = !this.useHeadPoseReferenceData
                },
              }],
            },
          },
        events: {
            dataPointMouseEnter: (event, chartContext, config) => {
              this.hpCurrentDataPointIndex = config.dataPointIndex
            },
          },
        },
        xaxis: {
          categories: this.headPoseData.map(s => this.formatHour(new Date(s.detectionTimestamp))),
        },
        yaxis: {
          min: 0,
          max: 90,
          labels: {
            formatter: val => {
                return val.toFixed(0) + '°'
            },
          },
        },
        theme: {
          monochrome: {
            enabled: true,
            color: '#2c3e50',
          },
        },
        noData: {
          text: this.headPoseDataStatus,
        },
        plotOptions: {
          bar: {
          },
        },
        title: {
          text: 'Head pose angle',
          style: {
            fontFamily: 'Helvetica',
          },
        },
        markers: {
          size: 4,
        },
        tooltip: {
          intersect: true,
          shared: false,
          fixed: {
            enabled: true,
            position: 'topRight',
            offsetX: 0,
            offsetY: 0,
          },
        },
      }
    },
    ambulatorySpeedChartOptions () {
      return {
        chart: {
          type: 'line',
          id: 'vuechart-as',
          events: {
            dataPointMouseEnter: (event, chartContext, config) => {
              this.asCurrentDataPointIndex = config.dataPointIndex
            },
          },
        },
        xaxis: {
          categories: this.ambulatorySpeedData.map(s => this.formatHour(new Date(s.timestamp))),
        },
        yaxis: {
          labels: {
            formatter: val => {
                return val.toFixed(0) + 's'
            },
          },
        },
        theme: {
          monochrome: {
            enabled: true,
            color: '#2c3e50',
          },
        },
        noData: {
          text: 'No data available',
        },
        plotOptions: {
          bar: {
          },
        },
        title: {
          text: 'Ambulatory Speed (in seconds)',
          style: {
            fontFamily: 'Helvetica',
          },
        },
        markers: {
          size: 4,
        },
        tooltip: {
          intersect: true,
          shared: false,
        },
      }
    },
  },
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
  background-color: rgba(216,216,216,.25);
  border-radius: 20px;
  padding: 32px;
  margin: 20px;
}
div>.apexcharts {
  min-width: 50%;
}
</style>
<style>
.custom-icon__headpose_chart {
  padding-left: 5px;
}
.head-pose-image {
  display: flex;
  flex-direction: column;
  height: 16rem;
  background: #D8D8D8;
  border: 1px solid #475669;
  box-shadow: 0 .35rem 1.42rem 0 rgba(0, 0, 0, 0.5);
  border-radius: 0.35rem;
  padding: 0;
  margin: 0;
  border-collapse: collapse;
}
</style>
